// 引入axios组件
import axios from 'axios';
import qs from 'qs'; // 处理数据  qs.stringify(params)
// 引入公共组件editor
import UE from '../../../../components/public/ue.vue';
import { checkRule } from '@/assets/js/public';
// 引入公共js文件
export default {
  components: { UE },
  data() {
    return {
      title: '', // 面包屑标题
      buttonProps: {
        type: 'ghost',
        size: 'small',
      },
      //= =========================以下是模态框相关
      modal1: false, // 模态框显示开关，true显示   false不显示
      cat_name: '', // 输入的名字
      cat_pid: '', // 选中的父级id
      cateid: '', // 分类id（修改时使用~）
    };
  },
  created() {
    this.$Spin.show();
    setTimeout(() => {
      this.$Spin.hide();
    }, 500);
  },
  computed: {
    categorylist() {
      return this.$store.state.article.articleCategory;
    },
    categoryonelist() {
      return this.$store.state.article.articleCategorySelect;
    },
  },
  methods: {
    // 添加文章分类（打开模态框）；
    addArticleCategory() {
      this.modal1 = true; // 模态框显示开关，true显示   false不显示
      this.cateid = '';
    },
    // 添加弹出框点击确定之后走的方法
    ok() {
      const self = this; // 将this对象附到一个不可更改的变量中~
      axios({
        method: 'post',
        url: '/admin/article/articleCategoryUpdate',
        data: {
          cat_name: this.cat_name,
          cat_pid: this.cat_pid,
          cateid: this.cateid,
        },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限

          if (response.data.code == 1) {
            self.$Message.success(response.data.msg);
            self.$store.commit('getArticleCateAgain');
            self.cat_name = '';
            self.cat_pid = '';
            // self.data6.splice(param.index, 1);//如果把那个1改成0，就是不删除
          } else {
            self.$Message.error(response.data.msg);
          }
        })
        .catch((response) => {
          self.$Message.error(response.data.msg);
        });
    },
    // 添加弹出框点击取消走的方法
    cancel() {
      this.modal1 = false;
    },
    // 点击每个一级分类前面的弹出框执行的事件
    letgo(getid) {
      this.$store.commit('changeCatePid', getid);
    },
    editCategory(cateid) {
      const self = this; // 将this对象附到一个不可更改的变量中~
      this.modal1 = true; // 模态框显示开关，true显示   false不显示
      axios({
        method: 'post',
        url: '/admin/article/articleCategoryEdit',
        data: { cateid },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限
          self.cat_name = response.data.cateinfo.cat_name;
          self.cat_pid = response.data.cateinfo.cat_pid;
          self.cateid = response.data.cateinfo.id;
        })
        .catch((response) => {
          self.$Message.error(response.data.msg);
        });
    },
    delCategory(cateid) {
      const self = this; // 将this对象附到一个不可更改的变量中~
      axios({
        method: 'post',
        url: '/admin/article/articleCategoryDel',
        data: { cateid },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限
          if (response.data.code == 1) {
            // self.data6.splice(param.index, 1);//如果把那个1改成0，就是不删除
            for (const i in self.categorylist) {
              const delid = self.categorylist[i].id;
              if (delid == cateid) {
                self.categorylist.splice(i, 1);
              }
            }
            self.$Message.success(response.data.msg);
          } else {
            self.$Message.error(response.data.msg);
          }
        })
        .catch((response) => {
          self.$Message.error('请求失败');
        });
    },
  },
};
